import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Autocomplete from '@mui/material/Autocomplete';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

//ICONS
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const theme = createTheme();
const useStyles = makeStyles()((theme) => ({
   textField: {
      width: '100%'
   },
   marginAuxT: {
      marginTop: '8px'
   },
   marginAuxR: {
      marginRight: '8px'
   },
   marginAuxL: {
      marginLeft: '8px'
   },
   marginIcon: {
      margin: '4px'
   },
   borderTop: {
      borderTop: `1px solid #bcbdbf`
   },
   aux: {
      backgroundColor: 'red'
   }
}));

function DatosAdicionalesAgregar(props) {
   const {classes, cx} = useStyles();
   const {
      titulo,
      campoObligatorio,
      infoSugerida,
      columnasDatosAdicionales,
      procesarDatosAdicionales,
      errorValidacion,
      closeModalCallback,
      closeModal,
      cancelarClick,
      objetoActual
   } = props;

   const [options, setOptions] = useState([]);
   /*
   Estados de control
   */
   const [value, setValue] = useState({value: ''});
   const [clave, setClave] = useState('');
   const [valor, setValor] = useState('');
   const [verDatosAdicionales, setVerDatosAdicionales] = useState(
      objetoActual != null && Object.keys(objetoActual).length > 1
   );

   //Cargar estados desde propiedades
   useEffect(() => {
      async function cargarPropiedadesAsync() {
         if (infoSugerida.length > 0) {
            const newOptions = await infoSugerida.map((item) => ({value: item}));
            setOptions(newOptions);
         }
      }
      cargarPropiedadesAsync();
      if (objetoActual && objetoActual !== null && objetoActual !== undefined) {
         setDatosAdicionales(objetoActual);
      }
   }, [infoSugerida, objetoActual]);

   /*
   Estados de datos
   */
   const [datosAdicionales, setDatosAdicionales] = useState({[campoObligatorio.name]: ''});

   async function agregarDatosAdicionales() {
      setDatosAdicionales({...datosAdicionales, [clave]: valor});
      const newOptions = options.filter((item) => item.value !== clave);
      setOptions(newOptions);
      setClave('');
      setValor('');
   }

   async function editarDatosAdicionales(event) {
      const claveDatoAdicional = event.currentTarget.name;
      setClave(claveDatoAdicional);
      setValor(datosAdicionales[claveDatoAdicional]);
   }

   async function eliminarDatosAdicionales(event) {
      const claveDatoAdicional = event.currentTarget.name;
      setOptions([...options, {value: claveDatoAdicional}]);
      const newDatosAdicionales = datosAdicionales;
      delete newDatosAdicionales[claveDatoAdicional];
      setDatosAdicionales(newDatosAdicionales);
   }

   function handleOnChangeObligatorio(event) {
      setDatosAdicionales({...datosAdicionales, [campoObligatorio.name]: event.target.value});
   }

   function handleOnchageValor(event) {
      setValor(event.target.value);
   }

   function onClickAceptar() {
      if (datosAdicionales[campoObligatorio.name] !== '') {
         if (closeModalCallback) {
            closeModalCallback(datosAdicionales);
         }
         if (procesarDatosAdicionales) {
            procesarDatosAdicionales(datosAdicionales);
         }
      } else {
         const errMsg = `El campo ${campoObligatorio.label} es obligatorio.`;
         if (errorValidacion) {
            errorValidacion(errMsg);
         } else {
            console.log(errMsg);
         }
      }
   }
   function onClickCancelar() {
      if (closeModal) {
         closeModal();
      } else {
         setValue({value: ''});
         setClave('');
         setValor('');
         setDatosAdicionales({[campoObligatorio.name]: ''});
      }
      if (cancelarClick) {
         cancelarClick();
      }
   }

   function handleChecked(event) {
      setVerDatosAdicionales(event.target.checked);
      setDatosAdicionales({
         [campoObligatorio.name]: datosAdicionales[campoObligatorio.name]
      });
   }

   return (
      <Grid container item xs={12} spacing={1}>
         <Grid item xs={12}>
            <Typography variant="h5" className={cx(classes.marginAuxL, classes.marginAuxT)}>
               {titulo}
            </Typography>
         </Grid>
         <Grid className={cx(classes.borderTop)} item xs={12}>
            <TextField
               autoFocus
               label={campoObligatorio.label}
               name={campoObligatorio.name}
               value={datosAdicionales[campoObligatorio.name]}
               onChange={handleOnChangeObligatorio}
               className={cx(classes.textField)}
               margin="dense"
               error={datosAdicionales[campoObligatorio.name] === ''}
               helperText="Este campo es obligatorio."
            />
         </Grid>
         <Grid className={cx(classes.borderTop)} item xs={12}>
            <Typography className={cx(classes.marginAuxL, classes.marginAuxT)}>
               Datos Adicionales:{' '}
               {
                  <Checkbox
                     color="primary"
                     inputProps={{'aria-label': 'checkbox datos adicionales'}}
                     checked={verDatosAdicionales}
                     onChange={handleChecked}
                  />
               }
            </Typography>
         </Grid>
         {verDatosAdicionales && (
            <>
               <Grid container item xs={12} spacing={1}>
                  <Grid item xs={4}>
                     <Autocomplete
                        clearText="limpiar"
                        value={value}
                        onChange={(event, newValue) => {
                           setValue(newValue);
                        }}
                        inputValue={clave}
                        onInputChange={(event, newInputValue) => {
                           setClave(newInputValue);
                        }}
                        disabled={datosAdicionales[campoObligatorio.name] === ''}
                        freeSolo
                        name={columnasDatosAdicionales[0]}
                        options={options}
                        getOptionLabel={(option) => (option === '' ? '' : option.value)}
                        renderInput={(params) => (
                           <TextField
                              {...params}
                              label={columnasDatosAdicionales[0]}
                              margin="dense"
                              error={datosAdicionales[campoObligatorio.name] === ''}
                              helperText={
                                 datosAdicionales[campoObligatorio.name] === ''
                                    ? `El campo ${campoObligatorio.label} obligatorio.`
                                    : ''
                              }
                           />
                        )}
                     />
                  </Grid>
                  {/*
                        error={datosAdicionales[campoObligatorio.name] === '' || clave === ''}
                        helperText={
                           datosAdicionales[campoObligatorio.name] === '' || clave === ''
                              ? `Los campos ${campoObligatorio.label} y ${columnasDatosAdicionales[0]} son obligatorios.`
                              : ''
                        }*/}
                  <Grid item xs={7}>
                     <TextField
                        name={columnasDatosAdicionales[1]}
                        label={columnasDatosAdicionales[1]}
                        value={valor}
                        onChange={handleOnchageValor}
                        margin="dense"
                        disabled={datosAdicionales[campoObligatorio.name] === '' || clave === ''}
                     />
                  </Grid>
                  <Grid container item xs={1} justifyContent="flex-end" alignItems="center">
                     <IconButton
                        onClick={agregarDatosAdicionales}
                        aria-label="agregar informacion adicional"
                        className={cx(classes.marginIcon)}
                        disabled={
                           datosAdicionales[campoObligatorio.name] === '' ||
                           clave === '' ||
                           valor === ''
                        }
                        size="large"
                     >
                        <AddCircleOutlineIcon />
                     </IconButton>
                  </Grid>
               </Grid>
               <Grid item xs={12}>
                  <TableContainer component={Paper}>
                     <Table size="small" aria-label="Tabla datos adicionales">
                        <TableHead>
                           <TableRow>
                              {columnasDatosAdicionales.map((item, index) => (
                                 <TableCell key={index} align="left">
                                    {item}
                                 </TableCell>
                              ))}
                              <TableCell align="right">Acciones</TableCell>
                           </TableRow>
                        </TableHead>
                        <TableBody>
                           {Object.keys(datosAdicionales).map((item) => {
                              if (item !== campoObligatorio.name) {
                                 return (
                                    <TableRow key={item}>
                                       <TableCell>{item}</TableCell>
                                       <TableCell>{datosAdicionales[item]}</TableCell>
                                       <TableCell align="right">
                                          <IconButton
                                             onClick={editarDatosAdicionales}
                                             aria-label="editar dato adicional"
                                             className={cx(classes.marginIcon)}
                                             name={item}
                                             size="small"
                                          >
                                             <EditIcon />
                                          </IconButton>
                                          <IconButton
                                             onClick={eliminarDatosAdicionales}
                                             aria-label="eliminar dato adicional"
                                             className={cx(classes.marginIcon)}
                                             size="small"
                                             name={item}
                                          >
                                             <DeleteIcon />
                                          </IconButton>
                                       </TableCell>
                                    </TableRow>
                                 );
                              } else {
                                 return null;
                              }
                           })}
                        </TableBody>
                     </Table>
                  </TableContainer>
               </Grid>
            </>
         )}
         <Grid
            className={cx(classes.marginAuxT, classes.borderTop)}
            container
            item
            xs={12}
            spacing={1}
            justifyContent="flex-end"
         >
            <Button
               className={cx(classes.marginAuxR)}
               size="small"
               color="secondary"
               onClick={onClickCancelar}
            >
               Cancelar
            </Button>
            <Button
               className={cx(classes.marginAuxL)}
               variant="contained"
               size="small"
               color="primary"
               onClick={onClickAceptar}
            >
               Aceptar
            </Button>
         </Grid>
      </Grid>
   );
}

DatosAdicionalesAgregar.propTypes = {
   /** Objeto con la información sobre el dato adicional obligatorio, name representa el nombre del objeto y label sera el texto con el que se muestra al usuario. */
   campoObligatorio: PropTypes.exact({name: PropTypes.string, label: PropTypes.string}),
   /** Opciones de autocompletado para los campos adicionales diferentes del campo obligatorio. */
   infoSugerida: PropTypes.arrayOf(PropTypes.string),
   /** Nombres que se mostraran como titulos de los pares clave-valor de los datos adicionales. */
   columnasDatosAdicionales: PropTypes.arrayOf(PropTypes.string),
   /** Titulo mostrado en la parte superior del componente. */
   titulo: PropTypes.string,
   /** Funcion a ejecutar cuando se hace click en aceptar. Toma un parametro con un objeto el cual contiene los pares clave-valor de los datos especificados. */
   procesarDatosAdicionales: PropTypes.func,
   /** Accion a ejecutar cuando sucede un error de validacion de los campos obligatorios. */
   errorValidacion: PropTypes.func,
   /** Funcion de cierre de modal si el componente es llamado dentro de un modal. */
   closeModal: PropTypes.func,
   /** Accion a ejecutar cuando cuando se hace click en aceptar para cerrar el modal. */
   closeModalCallback: PropTypes.func,
   /** Accion a ejecutar cuando se hace click en cancelar. */
   cancelarClick: PropTypes.func,
   /** Objeto con los pares clave-valor que se desean mostrar para su edicion.*/
   objetoActual: PropTypes.object
};

DatosAdicionalesAgregar.defaultProps = {
   titulo: 'Agregar Datos Adicionales',
   campoObligatorio: {name: 'foo0', label: 'Foo0Label'},
   infoSugerida: ['foo1', 'foo2', 'foo3', 'foo4'],
   columnasDatosAdicionales: ['Clave', 'Valor']
};
export default DatosAdicionalesAgregar;
